export default __webpack_public_path__ + "static/media/4t.7b16bd68.jpg";